/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
import * as __WEBPACK_EXTERNAL_MODULE_turndown__ from "turndown";
import * as __WEBPACK_EXTERNAL_MODULE_turndown_plugin_gfm_2be91617__ from "turndown-plugin-gfm";
function toMarkdown(html, options = {}) {
    if (!html) return '';
    try {
        const { codeBlockStyle = 'fenced', headingStyle = 'atx', emDelimiter = '*', strongDelimiter = '**', gfmExtension = true, removeTags = [
            "script",
            'style',
            'link'
        ] } = options;
        const turndown = new __WEBPACK_EXTERNAL_MODULE_turndown__["default"]({
            codeBlockStyle,
            headingStyle,
            emDelimiter,
            strongDelimiter
        });
        turndown.remove(removeTags);
        if (gfmExtension) turndown.use(__WEBPACK_EXTERNAL_MODULE_turndown_plugin_gfm_2be91617__.gfm);
        return turndown.turndown(html);
    } catch (error) {
        console.error('HTML to Markdown conversion failed:', error);
        return html;
    }
}
export { toMarkdown };

//# sourceMappingURL=to-markdown.mjs.map